import React, { memo } from 'react';
import { v1 as uuid } from 'uuid';

import {
  Field,
  connect as connectFormik,
  FieldProps,
  FormikProps,
} from 'formik';

import Input from 'components/Input';
import { IFormValues } from 'store/survey/surveyTypes';
import i18n from '../../../../../../../i18n';

interface IFormikConnect {
  formik: FormikProps<IFormValues>;
  isOwnerOrSupport?: boolean;
}

const mergeSumAndCountId = uuid();

const GridFieldsEditor: React.FC<IFormikConnect> = ({ isOwnerOrSupport }) => {
  return (
    <>
      {isOwnerOrSupport && (
        <Field name="data.mergeSumAndCount">
          {({ field }: FieldProps) => (
            <Input
              {...field}
              id={mergeSumAndCountId}
              type="checkbox"
              label={i18n.t('mergeSumAndCount', { ns: 'survey' }) as string}
              checked={field.value}
            />
          )}
        </Field>
      )}
    </>
  );
};

export default memo(connectFormik<any, IFormValues>(GridFieldsEditor));
